<i18n lang="yml" src='../i18n/ExamForm.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
        <h4 v-if="type == 'edit'">
          {{ $t('header') }}
        </h4>
        
        <h4 v-else>
          {{!exam ? `${$t('header_new')}` : `${$t('header_new_version')}`}}
        </h4>
      </div>
    </div>
    <flash :message_type="message_type" :message_text="message_text"/>
      <p class="border-bottom">
        <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
        <span v-if="type == 'edit'">
          {{ $t('description_edit') }}
        </span>
        <span v-else>
          {{!exam ? `${$t('description_new')}` : `${$t('description_new_version')}`}}
        </span>

      </p>

      <h5 class="margin-top heading-page">
        {{`${$t('exam_details')}`}}
      </h5>

      <Form ref="observer" v-slot="{ errors }" @submit="submitUserInput" @invalid-submit="setErrorMessage">
          <fieldset class="form-group border-bottom mt-4">
            <div class="row">
              <div class="col-md-12">

                <div class="form-group row">
                  <div class="col-md-4">
                    <Field 
                      :name="$t('test_id.label')" 
                      rules="required" 
                      v-slot="{ errors, field }"
                      v-model="examData.test_id">
                      <label :for="$t('test_id.label')"> 
                        {{$t('test_id.label')}} 
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('test_id.label')"
                        :disabled="!!exam"
                        name="test_id"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field" 
                        type="text">
                      <div class="invalid-feedback" id="test_id_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-4">
                    <Field 
                      :name="$t('version.label')" 
                      rules="required|numeric|greater_than_zero" 
                      v-slot="{ errors, field }"
                      v-model="examData.version_name">
                      <label :for="$t('version.label')"> 
                        {{$t('version.label')}} 
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('version.label')" 
                        name="version"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field" 
                        type="text">
                      <div class="invalid-feedback" id="version_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group">
                  <label :for="$t('inter_provincial_exam')">
                    {{$t('inter_provincial_exam')}}
                  </label>
                  <span class="red">*</span>
                  <div class="col-sm-6">
                    <div class="form-check form-check-inline" :class="{'is-invalid': errors[$t('inter_provincial_exam')]}">
                      <label class="form-check-label">
                        <Field
                        :name="$t('inter_provincial_exam')" 
                        rules="required"                
                        type="radio"
                        :id="`${$t('inter_provincial_exam')}_true`" 
                        :aria-checked="`${$t('inter_provincial_exam')}_true`" 
                        value=true 
                        v-model="examData.inter_provincial_exam"/>
                        {{$t('yes_val')}}
                      </label>

                    </div>
                    <div class="form-check form-check-inline" :class="{'is-invalid': errors[$t('inter_provincial_exam')]}">
                      <label class="form-check-label">
                        <Field
                        :id="`${$t('inter_provincial_exam')}_false`" 
                        :name="$t('inter_provincial_exam')" 
                        :aria-checked="`${$t('inter_provincial_exam')}_false`"
                        rules="required"                
                        type="radio"
                        value=false
                        v-model="examData.inter_provincial_exam"/>
                        {{$t('no_val')}}</label>
                    </div>
                      <div v-if="errors[$t('inter_provincial_exam')]" id="inter_provincial_exam_error" class="invalid-feedback">
                      <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        {{errors[$t('inter_provincial_exam')] }}
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-4">
                    <Field 
                      :name="$t('icem_id.label')" 
                      :rules="examData.inter_provincial_exam == 'true' ? 'required' : ''"
                      v-slot="{ errors, field }"
                      v-model="examData.icem_id">
                      <label :for="$t('icem_id.label')"> 
                        {{$t('icem_id.label')}} 
                      </label>

                      <span v-if="examData.inter_provincial_exam && examData.inter_provincial_exam == 'true'" class="red">*</span>
                      <input 
                        :id="$t('icem_id.label')" 
                        name="icem_id" 
                        type="text" 
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field">
                      <div class="invalid-feedback" id="inter_provincial_exam_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>  
                  </div>
                </div>
                <!-- Commenting this for now as apparently STO doesn't use it at the moment but leaving it in just in case they want it again -->
                <!-- <div class="form-group">
                    <label :for="$t('scheduled_online')">
                      {{$t('scheduled_online')}}
                    </label>
                    <span class="red">*</span>
                    <div class="col-sm-6" id="scheduled_online">
                      <div class="form-check form-check-inline" :class="{'is-invalid': errors[$t('scheduled_online')]}">
                        <label class="form-check-label">
                          <Field
                            :name="$t('scheduled_online')" 
                            rules="required"
                            v-model="examData.scheduled_online"
                            :id="`${$t('scheduled_online')}_true`" 
                            :aria-checked="`${$t('scheduled_online')}_true`" 
                            value=true 
                            type="radio"/>
                            {{$t('yes_val')}}
                        </label>

                      </div>
                      <div class="form-check form-check-inline" :class="{'is-invalid': errors[$t('scheduled_online')]}">
                        <label class="form-check-label">
                          <Field
                            :name="$t('scheduled_online')" 
                            rules="required"                
                            v-model="examData.scheduled_online"
                            :id="`${$t('scheduled_online')}_false`" 
                            :aria-checked="`${$t('scheduled_online')}_false`" 
                            value=false 
                            type="radio"/>
                            {{$t('no_val')}}
                        </label>
                      </div>
                      <div class="invalid-feedback" id="scheduled_online_error" v-if="errors[$t('scheduled_online')]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        {{errors[$t('scheduled_online')] }}
                      </div>
                    </div>
                </div> -->

                <div class="form-group row">
                  <div class="col-md-12 col-lg-9">
                    <Field 
                      :name="$t('name_en.label')" 
                      rules="required" 
                      v-slot="{ errors, field }"
                      v-model="examData.name.en">
                      <label :for="$t('name_en.label')"> 
                        {{$t('name_en.label')}}
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('name_en.label')" 
                        name="name_en"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field" 
                        type="text">
                      <div class="invalid-feedback" id="name_en_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12 col-lg-9">
                     <Field 
                      :name="$t('name_fr.label')" 
                      rules="required" 
                      v-slot="{ errors, field }"
                      v-model="examData.name.fr">
                      <label :for="$t('name_fr.label')"> 
                        {{$t('name_fr.label')}} 
                      </label>
                      <span class="red">*</span>
                      <input :id="$t('name_fr.label')" 
                        name="name_fr"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field" 
                        type="text">
                      <div class="invalid-feedback" id="name_fr_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-4">
                    <Field 
                      :name="$t('exam_type')" 
                      rules="required" 
                      v-slot="{ errors, field }"
                      v-model="examData.exam_type_id">
                      <label :for="$t('exam_type')"> 
                        {{$t('exam_type')}}
                      </label>
                      <span class="red">*</span>
                      <select 
                        v-bind="field" 
                        :id="$t('exam_type')" 
                        class="form-control"
                        :class="{'is-invalid': errors[0]}"
                        @change="changeSelect($event)">
                        <option v-for="examType in dropdownExamTypes" :key="examType.id" :value="examType.id">
                          {{examType.label}}
                        </option>
                      </select>
                      <div class="invalid-feedback" id="exam_type_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>
                  
                <div class="form-group row">
                  <div class="col-lg-5">
                    <Field 
                      :name="$t('required_resources.label')"
                      :rules="is_resources_required ? 'required' : ''"
                      v-slot="{ errors, field }"
                      v-model="examData.required_resources">
                      <label :for="$t('required_resources.label')"> {{$t('required_resources.label')}} </label>
                      <span class="red" v-if="is_resources_required">*</span>
                      <textarea :id="$t('required_resources.label')" name="required_resources" rows="6" class="form-control" :class="{'is-invalid': errors[0]}" v-bind="field"/>
        
                      <div class="invalid-feedback" id="required_resources" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-4">
                     <Field 
                      :name="$t('time_allowance')" 
                      rules="required|greater_than_zero|decimal_places:2"  
                      v-slot="{ errors, field }"
                      v-model="examData.time_allowance">
                      <label :for="$t('time_allowance')"> 
                        {{$t('time_allowance')}} 
                      </label>
                      <span class="red">*</span>
                      <input 
                        :id="$t('time_allowance')" 
                        name="time_allowance"
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field">         
                      <div class="invalid-feedback" id="time_allowance_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>   
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-4">
                    <Field 
                      :name="$t('number_of_questions')" 
                      rules="required|greater_than_zero|numeric" 
                      v-slot="{ errors, field }"
                      v-model="examData.number_of_questions">
                      <label :for="$t('number_of_questions')"> 
                        {{$t('number_of_questions')}} 
                      </label>
                      <span class="red">*</span>
                      <input 
                        :id="$t('number_of_questions')"
                        name="number_of_questions" 
                        type="number" 
                        class="form-control" 
                        :class="{'is-invalid': errors[0]}" 
                        v-bind="field">

              
                      <div class="invalid-feedback" id="time_allowance_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>  
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-12 col-lg-9" v-if="!loading">
                    <Field 
                      :name="$t('exam_program_associations')"  
                      rules="required"
                      v-slot="{ errors, field }"
                      v-model="examData.training_programs"
                      >
                      <label :for="$t('exam_program_associations')"> 
                        {{$t('exam_program_associations')}}
                      </label>

                      <span class="red">*</span>
                      <multi-select
                        :options="dropdownTrainingPrograms"
                        mode="tags"
                        :close-on-select="false"
                        :hideSelected="false"
                        :searchable="true"
                        :value="examData.training_programs"
                        v-bind="field" 
                        :create-option="false"
                        :canClear="true"
                        :class="{'is-invalid': errors[0]}" 
                        track-by="label"
                        label="label"
                      />
                      <input type="hidden" v-for="item in dropdownTrainingPrograms" :key="item.id" id="exam_program_associations" :value="item.id"/>
                      <div class="invalid-feedback" id="time_allowance_error" v-if="errors[0]">
                        <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                        <span>{{ errors[0] }}</span> 
                      </div>
                    </Field>  
                  </div>
                </div>

                <div class="border-bottom"></div>

                <h5 class="margin-top">
                  {{`${$t('exam_type_details')}`}}
                </h5>
                <div class="form-group row">
                  <div class="col-md-4">
                    <label for="maximum_retries"> 
                      {{$t('maximum_retries')}}
                    </label>
                    <input id="maximum_retries" disabled="true" name="maximum_retries" class="form-control" :value="examTypeFieldData.max_retries"/>
                  </div>
                </div>
                <div class="form-group row">
                  <div class="col-md-4">
                    <label for="time_between_retries"> {{$t('time_between_retries')}} </label>
                    <input disabled="true" id="time_between_retries" name="time_between_retries" class="form-control" :value="examTypeFieldData.time_between_retries"/>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-4">
                    <label for="pass_mark"> {{$t('pass_mark')}} </label>
                    <input id="pass_mark" disabled="true" name="pass_mark" class="form-control" :value="examTypeFieldData.pass_mark"/>
                  </div>
                </div>

                <div class="form-group row">
                  <div class="col-md-4">
                    <label for="current_fee"> {{$t('current_fee')}} </label>
                    <input id="current_fee" disabled="true" name="current_fee" class="form-control" :value="examTypeFieldData.current_fee"/>
                  </div>
                </div>

                <div class="border-bottom"></div>

                <div class="form-group row">
                  <div class="col-md-6">
                    <label for="status"> {{$t('status')}} </label>
                    <select id="status"  class="form-control" name="examData[status]" v-model="examData.status" :value="examData.status">
                      <option v-for="examStatus in examStatuses" :key="examStatus" :value="examStatus">{{$t(examStatus)}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <div v-if="Object.keys(errors).length > 0 && showErrorBanner" class="alert alert-danger" role="alert">
            <span class="red mr-2">
              <font-awesome-icon :icon="['far', 'exclamation-circle']"/>
            </span>
            {{ $t('error_warning') }}
          </div>
         
          <div class="btn-row d-flex">
            <button type="submit" class="btn btn-primary btn-success no-shadow" v-if="type=='new'">
              <font-awesome-icon :icon="['fa', 'save']" />
              {{ $t('create') }}
            </button>
            <template v-else>
              <button  type="submit" class="btn btn-primary btn-success no-shadow">
                <font-awesome-icon :icon="['fa', 'save']" />
                {{ $t('submit') }}
              </button>
              <button class="btn btn-danger" v-if="!hide_delete" :disabled="examData.status == 'active'" 
              :data-confirm="$t('confirm_delete')" data-method="delete" :href="buildDeleteUpdatePath(examData.id)">
                <font-awesome-icon :icon="['fa', 'trash-alt']" />
                {{ $t('delete_exam') }}
              </button>
            </template>
              <a class="btn btn-light ml-auto" :href="base_path">
              <font-awesome-icon :icon="['fa', 'times']" />
              {{ $t('cancel') }}
            </a>
          </div>
      </Form>
  </div>
</template>

<script>
  import flash from '../../../../shared/flash_messages/components/Flash.vue'
  import '../../../../../javascripts/application/vee-validate-rules.js'
  import { de } from 'date-fns/locale'
  import { setErrorMessage } from '../../../../shared/typescripts/error.ts'
  import { sendAjaxRequest, ajaxResponseMessage } from '../../../../shared/typescripts/ajax.ts'
  import { Form, Field } from 'vee-validate'

  export default {

    props: ['locale', 'exam', 'base_path', 'type', 'exam_types', 'statuses', 'training_programs', 'statuses', 'hide_delete'],

    components: {
      flash,
      Form,
      Field,
    },

    data() {
      return {
        examData: {
          exam_type_id: null,
          test_id: null,
          version_name: null,
          icem_id: "",
          name: {en: "", fr: ""},
          number_of_questions: null,
          inter_provincial_exam: null,
          time_allowance: 0,
          required_resources: "",
          scheduled_online: false,
          status: 'pending',
          training_programs: []
        },
        examTypes: [],
        examTypeFieldData: {},
        message_type: "",
        message_text: [],
        trainingPrograms: [],
        examStatuses: [],
        showErrorBanner: false,
        isNewExam: false,
        is_resources_required: false,
        value: null,
        loading: true,
        options: []
      }
    },

    created() {
      this.$i18n.locale = this.locale;
    },

    mounted() {
      try {
        if (this.exam){
          this.examData = JSON.parse(this.exam);
          if (this.examData.name == null) {
            this.isNewExam = true
            this.examData.name = {en: "", fr: ""}
            this.examData.inter_provincial_exam = null;
            this.examData.status = 'pending'
            this.examData.time_allowance = 0
          }
          else {
            this.examData.scheduled_online = this.examData.scheduled_online.toString()
            this.examData.inter_provincial_exam = this.examData.inter_provincial_exam.toString()
            this.examData.training_programs = this.examData.training_programs.map((tp) => {return tp["id"]})
          }
        }
        this.examStatuses = JSON.parse(this.statuses)
        // Setup exam types and deactivate any fields coming over from exam types
        this.examTypes = JSON.parse(this.exam_types);
        if(this.examData.exam_type_id !== null){
          this.findExamTypeData();
          // Commenting this for now as apparently STO doesn't use it at the moment but leaving it in just in case they want it again
          // this.examData.scheduled_online = this.lockFieldIfValue('scheduled_online', this.examTypeFieldData.scheduled_online)
        }

        this.trainingPrograms = JSON.parse(this.training_programs);
      }
      catch(err) {
        this.error = true; 
      }
      this.loading = false;
    },

    computed: {
      dropdownExamTypes() {
        let results = [];
        (this.examTypes).forEach((item) => {
          results.push({
            id: item.id,
            label: item.name[this.$i18n.locale],
          });
        });
        return results;
      },

      dropdownTrainingPrograms(){
        let results = [];
        (this.trainingPrograms).forEach((item) => {
          results.push({
            value: item.id,
            label: (`${item.trade_code} - ${item.name[this.locale]}`)
          });
        });
        return results;
      },
    },
    
    methods: {

      buildDeleteUpdatePath(id){
        let path = `${this.base_path}/${id}`
        return path
      },

      changeSelect(event) {
        this.examData.exam_type_id = event.target.value

        this.findExamTypeData();

        if (this.examTypeFieldData !== null) {
          this.examData.number_of_questions = this.examTypeFieldData.number_of_questions
          this.examData.time_allowance = this.examTypeFieldData.time_allowance
          // Commenting this for now as apparently STO doesn't use it at the moment but leaving it in just in case they want it again
          // this.examData.scheduled_online = this.lockFieldIfValue('scheduled_online', this.examTypeFieldData.scheduled_online)
          this.is_resources_required = this.examTypeFieldData.inventory_required 
        } else {
          this.is_resources_required = false
        }
      },
      setErrorMessage({ valuese, errors, results }) {
        setErrorMessage(this, errors, true)
      },

      findExamTypeData(){
        this.examTypeFieldData = this.examTypes.find((examType) => {
          return examType.id == this.examData.exam_type_id
        }) || null
      },

      lockFieldIfValue(field, item){
        if(item !== null){
          document.getElementById(field).disabled = true;
          return item
        }
        else return null
      },
  
      submitUserInput(event){
        let payload = []
        payload = { exam: this.examData }
        this.message_text = [];
        let send_type = 'POST'
        let path = this.base_path

        if (this.type == "edit") {
          send_type = "PUT"
          path = this.buildDeleteUpdatePath(this.examData.id)
        
        }

        sendAjaxRequest(send_type, path, 'json', payload, ajaxResponseMessage, this.throwError)
      },

      buildDeleteUpdatePath(id) {
        return `${this.base_path}/${id}`
      },

      throwError() {
        console.log("Error")
      }
    }
  }
  
</script>
